if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.variantList = this.productInfo.querySelector('[data-variant-type="Talla"]');
      this.customSelect = this.querySelector('custom-select');
      this.listbox = this.querySelector('.custom-select__listbox');
      this.selectedOption = this.querySelector('[aria-selected="true"]');
      this.button = this.querySelector('.custom-select__btn');


      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
      this.handleChange();
      this.handleChangeAtc();
      this.handleChangePrice();
    }

    handleChange() {
      if (this.variantList) {
        this.variantList.addEventListener('change', (event) => {
          this.updateOptionSticky(event.target);
        });
      }
      if (this.customSelect) {
        this.customSelect.addEventListener('change', () => {
          this.updateVariantList();
        });
      }
    }

    updateOptionSticky(option) {
      if (option) {
        const selectedTarget = this.querySelector(`#${option.id}`);
        this.selectOption(selectedTarget);
      } else {
        this.button.querySelector('span').textContent = "";
      }
    }

    updateVariantList() {
      const optionId = this.listbox.getAttribute('aria-activedescendant');
      this.variantList.querySelector(`#${optionId}`).click();
    }

    selectOption(option) {
      if (option !== this.selectedOption) {
        this.button.firstElementChild.textContent = option.firstElementChild.textContent;
        this.listbox.setAttribute('aria-activedescendant', option.id);
        this.selectedOption = option;
      }
    }

    handleChangeAtc() {
      this.buttonAtcForm = this.querySelector('.product-info__add-button');
      this.buttonAtcForm.addEventListener('click', () => {
        this.productForm.querySelector('.product-info__add-button button').click();
      });

      this.productForm.addEventListener('change', () => {
        setTimeout(() => {
          this.buttonAtcForm.innerHTML = this.productForm.querySelector('.product-info__add-button button').outerHTML;
        }, 500);
      });
    }

    handleChangePrice() {
      this.priceVariant = this.querySelector('.price');
      this.priceVariantTarget = this.productInfo.querySelector('.price');
      if (this.priceVariant && this.productInfo && this.priceVariantTarget) {
        this.productInfo.addEventListener('change', () => {
          setTimeout(() => {
            this.priceVariant.innerHTML = this.priceVariantTarget.innerHTML;
          }, 500);
        });
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productForm && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
